/**
 * Shared API client utilities for Turbo Stream/JSON endpoints.
 *
 * Exposes window.apiClient for small domain-specific API wrappers that do not
 * use ES modules yet. Handles request headers, JSON parsing, Turbo Stream
 * rendering, and normalized Error objects.
 */
loadOnce('api-client', function () {
    var STREAM_HEADERS = {
        'Accept': 'text/vnd.turbo-stream.html, application/json',
        'Content-Type': 'application/json'
    };
    var JSON_HEADERS = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    };

    function extractFirstDetail(details) {
        if (!details) return null;
        var firstKey = Object.keys(details)[0];
        if (firstKey && details[firstKey] && details[firstKey][0]) {
            return details[firstKey][0];
        }
        return null;
    }

    async function request(method, url, body, opts) {
        opts = opts || {};
        var acceptStream = opts.acceptStream !== false;
        var headers = acceptStream ? STREAM_HEADERS : JSON_HEADERS;
        var init = { method: method, credentials: 'same-origin', headers: Object.assign({}, headers) };
        if (body !== undefined && body !== null) {
            init.body = JSON.stringify(body);
        }

        var response = await fetch(url, init);
        var contentType = response.headers.get('Content-Type') || '';

        if (acceptStream && contentType.indexOf('text/vnd.turbo-stream.html') !== -1) {
            var streamHtml = await response.text();
            if (window.Turbo && typeof window.Turbo.renderStreamMessage === 'function') {
                window.Turbo.renderStreamMessage(streamHtml);
            }
            return { turboStream: true };
        }

        var payload = null;
        try { payload = await response.json(); } catch (_e) { payload = null; }

        if (!response.ok || (payload && payload.success === false)) {
            var message = (payload && (payload.error || payload.message))
                || extractFirstDetail(payload && payload.details)
                || ('Request failed (HTTP ' + response.status + ')');
            var err = new Error(message);
            err.status = response.status;
            err.details = (payload && payload.details) || null;
            throw err;
        }

        return payload && payload.data ? payload.data : null;
    }

    window.apiClient = {
        STREAM_HEADERS: STREAM_HEADERS,
        JSON_HEADERS: JSON_HEADERS,
        extractFirstDetail: extractFirstDetail,
        request: request
    };
});
